<!-- ------------------Hero Section------------ -->
<div class="softwaredev-section-bg">
    <section class="softwaredev-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-5">
                    <h1 class="softwaredev-heading mb-3">
                        Mobile App Development Service Built for Growth & Innovation
                    </h1>
                    <!-- <p class="softwaredev-subheading1 mb-4">
                        Powered by AI
                    </p> -->
                    <p class="softwaredev-subheading2 mb-4">
                        Turn your ideas into standard, real-world mobile app with Kalpita Technologies, your partner for
                        custom, high-performance app development.
                    </p>
                    <div class="mb-5 contact-btn">
                        <button class="btn hire-btn hire" (click)="getAFreeQuote()">
                            Get a Free Quote
                        </button>
                    </div>
                </div>

                <div class="col-lg-7 text-center">
                    <video #heroVideo preload="auto" src="../../../../assets/services/mobile-dev/mbldev-herovideo.webm"
                        class="img-fluid hero-image" autoplay loop muted playsinline disablePictureInPicture>
                    </video>
                </div>
            </div>
        </div>
    </section>
</div>
<!-- ============== SERVICE OVERVIEW SECTION ================ -->
<!-- <section class="service-overview-section">
    <div class="container">
        <div class="row align-items-center">

            <div class="col-lg-5">
                <h2 class="overview-heading">Service Overview</h2>
                <p class="overview-text">
                    At Kalpita Technologies, our software development services are designed to help businesses scale smarter, innovate faster, and stay ahead of the curve. We build solutions that are not only reliable and secure but also tailored to your unique business goals.
                </p>
                <p class="overview-text">
                    Whether you need a customer-facing application, an enterprise platform, or cloud-native solutions, our team ensures seamless integration, future-ready architecture, and measurable business impact.
                </p>
            </div>

            <div class="col-lg-7">
                <div class="service-display-wrapper">
             
                    <div class="background-shape"></div>
                 
                    <div class="arc-path"></div>
              
                    <div class="center-graphic">
                        <img src="https://i.ibb.co/wJb20YV/center-graphic.png" alt="Core Technology">
                    </div>
                    <div class="service-points-container">
                        <div *ngFor="let service of services; let i = index" 
                             class="service-point"
                             [ngClass]="{ 'active': i === selectedServiceIndex }"
                             [style.transform]="getPointTransform(i)"
                             (click)="selectService(i)">
                            
                            <div class="icon">
                 
                                <img *ngIf="i === selectedServiceIndex" [src]="service.icon" class="active-icon-graphic" [alt]="service.title">
                            </div>
                            <div class="label">{{ service.title }}</div>
                        </div>
                    </div>

                    <div class="active-service-details" [attr.key]="selectedServiceIndex">
                         <h3 class="active-title">{{ services[selectedServiceIndex].title }}</h3>
                         <p class="active-description">{{ services[selectedServiceIndex].description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- ============== CUSTOM SOFTWARE DEVELOPMENT PROCESS ================ -->
<section class="dev-process-section">
    <div class="container">
        <!-- Section Header -->
        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-9">
                <h2 class="section-heading-process">Our Proven Approach to Building Scalable Mobile Applications</h2>
                <!-- <p class="section-subheading-process mt-3">Our process ensures every project is <strong>strategic,
                        transparent, and result-driven:</strong>
                </p> -->
            </div>
        </div>

        <!-- Process Cards Container -->
        <div class="process-cards-container">
            <div class="process-card" *ngFor="let step of developmentProcess; let i = index"
                [ngClass]="{ 'card-blue': i % 2 === 0, 'card-white': i % 2 !== 0 }">

                <div class="process-icon-wrapper">
                    <img [src]="step.icon" [alt]="step.title" class="process-icon">
                </div>

                <h3 class="process-title">{{ step.title }}</h3>
                <p class="process-description">{{ step.description }}</p>
            </div>
        </div>
    </div>
</section>
<!-- =================== WHY CHOOSE US SECTION =================== -->
<!-- ADDED: Template Reference & Animation Class Binding -->
<section class="why-choose-us-section py-5" #whyChooseSection [class.start-animation]="isWhyChooseVisible">
    <div class="container">
        <!-- Section Header -->
        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-8">
                <h2 class="section-heading">Why Choose Kalpita Technologies for Your Mobile App Success?</h2>
            </div>
        </div>

        <!-- Features Grid -->
        <div class="row g-4">
            <!-- Left Column: Dynamically takes the first half -->
            <div class="col-lg-6 d-flex flex-column">
                <div class="feature-card flex-grow-1 mb-4"
                    *ngFor="let item of whyChooseFeatures.slice(0, whyChooseFeatures.length / 2)">
                    <!-- The simple icon container -->
                    <div class="icon-container">
                        <img [src]="item.icon" [alt]="item.title" class="icon-image">
                    </div>
                    <!-- The text content -->
                    <div class="card-content">
                        <h3 class="card-title">{{ item.title }}</h3>
                        <p class="card-description">{{ item.description }}</p>
                    </div>
                </div>
            </div>

            <!-- Right Column: Dynamically takes the second half -->
            <div class="col-lg-6 d-flex flex-column">
                <div class="feature-card flex-grow-1 mb-4"
                    *ngFor="let item of whyChooseFeatures.slice(whyChooseFeatures.length / 2, whyChooseFeatures.length)">
                    <!-- The simple icon container -->
                    <div class="icon-container">
                        <img [src]="item.icon" [alt]="item.title" class="icon-image">
                    </div>
                    <!-- The text content -->
                    <div class="card-content">
                        <h3 class="card-title">{{ item.title }}</h3>
                        <p class="card-description">{{ item.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- =================== FEATURES & INCLUSIONS SECTION =================== -->
<div class="features-inclusion-bg">
    <!-- ADDED: Template Reference & Animation Class Binding -->
    <section class="features-section container py-5" #featuresSection [class.start-animation]="isFeaturesVisible">
        <!-- Centered Header -->
        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-10">
                <h2 class="features-heading">Mobile App Features & What’s Included</h2>
            </div>
        </div>

        <div class="row align-items-center">
            <!-- Left Column: Features List -->
            <div class="col-lg-6">
                <div class="features-list-wrapper">

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">Platform & Technology Choice: Android (Kotlin/Java), iOS
                            (Swift/Objective-C), Cross-Platform (Flutter, React Native)</p>
                    </div>

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">Custom UI/UX Design: Tailored mobile interfaces with intuitive
                            navigation and responsive behavior</p>
                    </div>

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">API Integration & Backend Services: Secure connection with cloud,
                            on-premise, third-party services </p>
                    </div>

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">Performance Optimization: Speed, reliability, minimal crash rates, and
                            efficient app size</p>
                    </div>

                    <!-- <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">AI-Powered Mobile Application Development</p>
                    </div> -->

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">App Store Optimization (ASO) support: Title, description and keywords
                            for “best mobile app developers near me” search visibility</p>
                    </div>

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">Analytics & Insights: Tracking usage, user behavior, retention &
                            engagement metrics</p>
                    </div>

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">Maintenance & Support: Bug-fixes, updates, feature additions, platform
                            upgrades</p>
                    </div>

                    <div class="feature-item">
                        <img src="../../../../assets/home/arrow-indicator.svg" alt="Indicator" class="feature-arrow">
                        <p class="feature-text">Documentation & Training: Full handover, code documentation, knowledge
                            transfer to your team</p>
                    </div>

                </div>
            </div>

            <!-- Right Column: Image -->
            <div class="col-lg-6 d-flex justify-content-center">
                <div class="features-image-wrapper">
                    <!-- Update this path to your specific feature image -->
                    <img src="../../../../assets/services/mobile-dev/mobiledev-featuresimage.png"
                        alt="Software Development Features" class="img-fluid features-img">
                </div>
            </div>
        </div>
    </section>
</div>
<!-- Technologies Section -->
<app-suite-technologies></app-suite-technologies>
<!-- =================== SUCCESS STORIES SECTION =================== -->
<section class="success-stories-section py-5">
    <div class="container">
        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-8">
                <h2 class="section-heading">Success Stories</h2>
                <p class="section-subheading mt-3">Proven Mobile App Projects That Delivered Results,</p>
            </div>
        </div>
    </div>
    <div class="timeline-container">
        <div class="timeline-wrapper">
            <div class="content-layout">
                <!-- Cards Stack -->
                <div class="cards-stack">
                    <div *ngFor="let item of visibleCards" class="card-wrapper"
                        [class.card-top]="item.position === 'top'" [class.card-center]="item.position === 'center'"
                        [class.card-bottom]="item.position === 'bottom'" (click)="selectCard(item.position)">

                        <div class="card">
                            <div class="card-image">
                                <img [src]="item.card.image" [alt]="item.card.title">
                                <div class="card-overlay"></div>
                            </div>

                            <div class="card-badge" *ngIf="item.position === 'center'">
                                <span class="year-badge">{{ item.card.year }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Text Content - Only shows for center card -->
                <div class="text-content">
                    <!-- Check if cards array is not empty before accessing -->
                    <ng-container *ngIf="timelinecards.length > 0">
                        <h2 class="content-year">{{ timelinecards[selectedIndex].title }}</h2>
                        <p class="content-description">{{ timelinecards[selectedIndex].description }}</p>
                    </ng-container>
                </div>

                <!-- Vertical Carousel Dots -->
                <div class="carousel-dots-vertical" *ngIf="showCarouselDots">
                    <button *ngFor="let card of timelinecards; let i = index" class="dot"
                        [class.active]="i === selectedIndex" (click)="goToCard(i)"
                        [attr.aria-label]="'Go to ' + card.year">
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- FAQ -->
<app-faq [faqList]="mbldevFaqs"></app-faq>
<!-- Final CTA -->
<div class="final-cta-bg">
    <img src="../../../../assets/industries/healthcare/half-tablet.png" alt="Decorative capsule"
        class="cta-capsule-img">
    <section id="final-cta" class="final-cta-section container">
        <div class="section-header text-center mx-auto">
            <!-- <h2>Final CTA</h2> -->
        </div>
        <div class="row align-items-center">
            <div class="col-lg-6 cta-content-col">
                <h2 class="cta-heading-small">Ready to bring your mobile app idea to life?</h2>
                <p style="color: #ffffff;" class="cta-subheading mb-4">Let’s build the next-generation mobile experience together!</p>
                <!-- <h1 class="cta-heading-large mb-3">Health Care Industry?</h1>
        <p class="cta-subheading mb-4">
          Let’s build software that’s made for YOU, not everyone else. 
        </p> -->
                <div class="mb-5 cta-btn-group">
                    <button class="btn btn-schedule-demo" (click)="bookAFreeCall()">
                        Schedule Your Free Consultation
                    </button>
                </div>
            </div>
            <div class="col-lg-6 text-center">
                <img src="../../../../assets/industries/healthcare/health-pod-clinic.png" alt="Health POD Clinic"
                    class="img-fluid cta-clinic-image">
            </div>
        </div>
    </section>
</div>
<!-- Explore More Services -->
<app-explore-more-services></app-explore-more-services>